/**
 * Map error codes to messages.
 *
 * CustomerErrorCode: https://shopify.dev/docs/api/storefront/unstable/enums/CustomerErrorCode
 */

export const authenticationErrorMessage: Record<string, string> = {
  UNIDENTIFIED_CUSTOMER: "Incorrect email or password",
};

export const recoverPasswordErrorMessage: Record<string, string> = {
  UNIDENTIFIED_CUSTOMER: "Incorrect email",
};
